import React from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { lang } from 'src/helpers';

const Certificate = React.memo(({ url }) => (
  <div className={'mc-certificate'}>
    <div className={'mc-certificate__title'}>{lang.t('Diploma')}</div>
    <div className={'mc-certificate__view'}>
      <img src={url} />
    </div>
    <div className={'mc-certificate__bottom'}>
      <SVGIcon iconname={BASE_ICONS.PDF} />
      <div className={'mc-grow'}>Certificate.pdf</div>
      <a title='Certificate.pdf' href={url} target='_blank' rel='noreferrer'>
        {lang.t('View')}
      </a>
    </div>
  </div>
));
Certificate.displayName = 'Certificate';

export default Certificate;
